import { Header } from '@/src/elements/header'
import { CommunitiesMobileSearch } from '@/src/features/community/ui/screens/CommunitiesMobileSearch'
import { ICON } from '@/src/general/enums/icons'
import { useBackHandlePress } from '@/src/general/hooks/useBackHandlePress'

export default function CommunitiesSearchScreen() {
  const { handleBackPress } = useBackHandlePress({ pathname: '/communities' })
  return (
    <>
      <Header leftButtons={[{ startIcon: ICON.ARROW_LEFT, onPress: handleBackPress, type: 'icon' }]} title="" />
      <CommunitiesMobileSearch />
    </>
  )
}
